import { Serializer } from "@sabyr-dev/mist_core/model/datasource";
import {
	ChartFrontend, ListFrontend, PqItemFrontend, ScoreFrontend, SectionFrontend,
	SettingsFrontend
} from "@sabyr-dev/mist_core/view/frontend";
import { ElibraryFrontendFactory } from "@sabyr-dev/mist_elibrary";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyChartFrontend } from "./chart";
import { AcademyItemFrontend } from "./item";
import { AcademyListFrontend } from "./list";
import { AcademyScoreFrontend } from "./score";
import { AcademySectionFrontend } from "./section";
import { AcademySettingsFrontend } from "./settings";

export {AcademyListFrontend} from "./list";
export {AcademyItemFrontend} from "./item";
export {AcademySettingsFrontend} from "./settings";
export {AcademyScoreFrontend} from "./score";
export {AcademySectionFrontend} from "./section";
export {AcademyChartFrontend} from "./chart";

export class AcademyFrontendFactory extends ElibraryFrontendFactory {
	listFrontend(item: Serializer<Question>): ListFrontend<Question> { return new AcademyListFrontend(item); }
	itemFrontend(item: Serializer<Question>): PqItemFrontend<Question> { return new AcademyItemFrontend(item); }
	scoreFrontend(): ScoreFrontend { return new AcademyScoreFrontend(); }
	sectionFrontend(quiz: Serializer<Quiz>, item: Serializer<Question>): SectionFrontend<Quiz, Question> { return new AcademySectionFrontend(quiz, item); }
	settingsFrontend(item: Serializer<Question>): SettingsFrontend<Question> { return new AcademySettingsFrontend(item); }
	chartFrontend(product: Serializer<Product>): ChartFrontend<Product, Attempt, Quiz> { return new AcademyChartFrontend(product); }
}
